export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/11a14d9b63ec892bb84cea8c67204259.svg";